import type { SiteVersion } from '../../../../../../core/system/rendering/types.js';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export const mapSiteversionToDeviceType = (
  siteVersion: SiteVersion,
): DeviceType => (siteVersion === 'phone' ? 'mobile' : siteVersion);
